<template>
    <div class="mh-card-toolbar">
        <div class="left"><slot/></div>
        <div class="right"><slot name="right"/></div>
        <div class="clear"></div>
    </div>
</template>

<script>
    export default {
        name: "CardToolbar"
    }
</script>

<style lang="scss" scoped>
    .mh-card-toolbar {
        background: #f3f3f3;
        border-bottom: 1px solid #dee2e6;

        padding: 3px 0.3rem 0.3rem 1rem;

        /*min-height: 38px;*/
        overflow: hidden;

        .left {
            float: left;
        }

        .right {
            float: right;
            text-align: right;
        }

        .clear::after {
            content: "";
            clear: both;
            display: table;
        }

        button, a {
            padding: 0.2rem 0.4rem;
            line-height: normal;
            font-size: 0.82rem;

            background-color: transparent;
            border: 0;
            color: #47697c;
            border-radius: 0.2rem;
            margin-right: 0.2rem;

            &.icon-only i {
                margin-right: 0 !important;
            }

            &.btn-warning:hover {
                background: #d97d07 !important;
            }

            i {
                margin-right: 0.4rem;
            }

            &:hover {
                background: #346ea6;
                color: white;
                text-decoration: none;
            }
        }
    }
</style>
